<template>
    <div class="hc-toast" :class="className" v-if="toast">
        <fa-icon :icon="icon" class="mr-2" v-if="icon"></fa-icon>
        <span>{{ message }}</span>

        <hec-close-button
            @closeClick="closeToast"
            help-text="Close toast"
            class="text-white"
        ></hec-close-button>
    </div>
</template>

<script>
import HecCloseButton from "@/components/global/HecCloseButton";
import { store } from "@/shared/store.js";
import { get } from "lodash-es";

export default {
    name: "HecToast",
    components: {
        HecCloseButton
    },
    data() {
        return {
            storeState: store.state
        };
    },
    computed: {
        className() {
            return "bg-" + this.toast.severity;
        },
        icon() {
            return get(this.toast, "icon") || null;
        },
        message() {
            return get(this.toast, "message") || null;
        },
        toast() {
            return get(this.storeState, "toast") || null;
        }
    },
    methods: {
        closeToast() {
            store.clearToast();
        }
    }
};
</script>

<style lang="scss">
.hc-toast {
    position: absolute;
    color: #fff;
    left: 1rem;
    right: 1rem;
    bottom: 1rem;
    padding: 0.75rem 1rem;
    border-radius: 0.25rem;
    z-index: 100;
}
</style>
